// source: proto/reportpb/profitandloss.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_type_date_pb = require('../../google/type/date_pb.js');
goog.object.extend(proto, google_type_date_pb);
var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js');
goog.object.extend(proto, proto_utilspb_pagination_pb);
goog.exportSymbol(
  'proto.reportpb.ListDetailsProfitAndLossRequest',
  null,
  global
);
goog.exportSymbol(
  'proto.reportpb.ListDetailsProfitAndLossResponse',
  null,
  global
);
goog.exportSymbol(
  'proto.reportpb.ListDetailsProfitAndLossSummary',
  null,
  global
);
goog.exportSymbol('proto.reportpb.ListProfitAndLossRequest', null, global);
goog.exportSymbol('proto.reportpb.ListProfitAndLossResponse', null, global);
goog.exportSymbol('proto.reportpb.ListProfitAndLossSummary', null, global);
goog.exportSymbol('proto.reportpb.ProfitAndLoss', null, global);
goog.exportSymbol('proto.reportpb.ProfitAndLossDetails', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ProfitAndLoss = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ProfitAndLoss, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ProfitAndLoss.displayName = 'proto.reportpb.ProfitAndLoss';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ProfitAndLossDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ProfitAndLossDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ProfitAndLossDetails.displayName =
    'proto.reportpb.ProfitAndLossDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListProfitAndLossRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ListProfitAndLossRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListProfitAndLossRequest.displayName =
    'proto.reportpb.ListProfitAndLossRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListProfitAndLossResponse = function(opt_data) {
  jspb.Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.reportpb.ListProfitAndLossResponse.repeatedFields_,
    null
  );
};
goog.inherits(proto.reportpb.ListProfitAndLossResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListProfitAndLossResponse.displayName =
    'proto.reportpb.ListProfitAndLossResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListProfitAndLossSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ListProfitAndLossSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListProfitAndLossSummary.displayName =
    'proto.reportpb.ListProfitAndLossSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListDetailsProfitAndLossRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ListDetailsProfitAndLossRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListDetailsProfitAndLossRequest.displayName =
    'proto.reportpb.ListDetailsProfitAndLossRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListDetailsProfitAndLossSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ListDetailsProfitAndLossSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListDetailsProfitAndLossSummary.displayName =
    'proto.reportpb.ListDetailsProfitAndLossSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListDetailsProfitAndLossResponse = function(opt_data) {
  jspb.Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.reportpb.ListDetailsProfitAndLossResponse.repeatedFields_,
    null
  );
};
goog.inherits(proto.reportpb.ListDetailsProfitAndLossResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListDetailsProfitAndLossResponse.displayName =
    'proto.reportpb.ListDetailsProfitAndLossResponse';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.reportpb.ProfitAndLoss.prototype.toObject = function(
    opt_includeInstance
  ) {
    return proto.reportpb.ProfitAndLoss.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.reportpb.ProfitAndLoss} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.reportpb.ProfitAndLoss.toObject = function(includeInstance, msg) {
    var f,
      obj = {
        processDate:
          (f = msg.getProcessDate()) &&
          google_type_date_pb.Date.toObject(includeInstance, f),
        accountId: jspb.Message.getFieldWithDefault(msg, 2, 0),
        correspondent: jspb.Message.getFieldWithDefault(msg, 3, ''),
        branch: jspb.Message.getFieldWithDefault(msg, 4, ''),
        accountNo: jspb.Message.getFieldWithDefault(msg, 5, ''),
        masterAccountNo: jspb.Message.getFieldWithDefault(msg, 6, ''),
        rep: jspb.Message.getFieldWithDefault(msg, 7, ''),
        originalCusip: jspb.Message.getFieldWithDefault(msg, 8, ''),
        assetType: jspb.Message.getFieldWithDefault(msg, 9, ''),
        symbol: jspb.Message.getFieldWithDefault(msg, 10, ''),
        symbolDescription: jspb.Message.getFieldWithDefault(msg, 11, ''),
        realized: jspb.Message.getFieldWithDefault(msg, 12, ''),
        marketValue: jspb.Message.getFieldWithDefault(msg, 13, ''),
        plType: jspb.Message.getFieldWithDefault(msg, 16, ''),
        ytdRealized: jspb.Message.getFieldWithDefault(msg, 17, ''),
        systemDate:
          (f = msg.getSystemDate()) &&
          google_type_date_pb.Date.toObject(includeInstance, f),
        subAccountNo: jspb.Message.getFieldWithDefault(msg, 21, ''),
        shortTermGain: jspb.Message.getFieldWithDefault(msg, 22, ''),
        shortTermLoss: jspb.Message.getFieldWithDefault(msg, 23, ''),
        shortTermNet: jspb.Message.getFieldWithDefault(msg, 24, ''),
        longTermGain: jspb.Message.getFieldWithDefault(msg, 25, ''),
        longTermLoss: jspb.Message.getFieldWithDefault(msg, 26, ''),
        longTermNet: jspb.Message.getFieldWithDefault(msg, 27, ''),
        ytdShortTermGain: jspb.Message.getFieldWithDefault(msg, 28, ''),
        ytdShortTermLoss: jspb.Message.getFieldWithDefault(msg, 29, ''),
        ytdShortTermNet: jspb.Message.getFieldWithDefault(msg, 30, ''),
        ytdLongTermGain: jspb.Message.getFieldWithDefault(msg, 31, ''),
        ytdLongTermLoss: jspb.Message.getFieldWithDefault(msg, 32, ''),
        ytdLongTermNet: jspb.Message.getFieldWithDefault(msg, 33, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ProfitAndLoss}
 */
proto.reportpb.ProfitAndLoss.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ProfitAndLoss();
  return proto.reportpb.ProfitAndLoss.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ProfitAndLoss} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ProfitAndLoss}
 */
proto.reportpb.ProfitAndLoss.deserializeBinaryFromReader = function(
  msg,
  reader
) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new google_type_date_pb.Date();
        reader.readMessage(
          value,
          google_type_date_pb.Date.deserializeBinaryFromReader
        );
        msg.setProcessDate(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setAccountId(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setCorrespondent(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setBranch(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setAccountNo(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setMasterAccountNo(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setRep(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setOriginalCusip(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setAssetType(value);
        break;
      case 10:
        var value = /** @type {string} */ (reader.readString());
        msg.setSymbol(value);
        break;
      case 11:
        var value = /** @type {string} */ (reader.readString());
        msg.setSymbolDescription(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setRealized(value);
        break;
      case 13:
        var value = /** @type {string} */ (reader.readString());
        msg.setMarketValue(value);
        break;
      case 16:
        var value = /** @type {string} */ (reader.readString());
        msg.setPlType(value);
        break;
      case 17:
        var value = /** @type {string} */ (reader.readString());
        msg.setYtdRealized(value);
        break;
      case 18:
        var value = new google_type_date_pb.Date();
        reader.readMessage(
          value,
          google_type_date_pb.Date.deserializeBinaryFromReader
        );
        msg.setSystemDate(value);
        break;
      case 21:
        var value = /** @type {string} */ (reader.readString());
        msg.setSubAccountNo(value);
        break;
      case 22:
        var value = /** @type {string} */ (reader.readString());
        msg.setShortTermGain(value);
        break;
      case 23:
        var value = /** @type {string} */ (reader.readString());
        msg.setShortTermLoss(value);
        break;
      case 24:
        var value = /** @type {string} */ (reader.readString());
        msg.setShortTermNet(value);
        break;
      case 25:
        var value = /** @type {string} */ (reader.readString());
        msg.setLongTermGain(value);
        break;
      case 26:
        var value = /** @type {string} */ (reader.readString());
        msg.setLongTermLoss(value);
        break;
      case 27:
        var value = /** @type {string} */ (reader.readString());
        msg.setLongTermNet(value);
        break;
      case 28:
        var value = /** @type {string} */ (reader.readString());
        msg.setYtdShortTermGain(value);
        break;
      case 29:
        var value = /** @type {string} */ (reader.readString());
        msg.setYtdShortTermLoss(value);
        break;
      case 30:
        var value = /** @type {string} */ (reader.readString());
        msg.setYtdShortTermNet(value);
        break;
      case 31:
        var value = /** @type {string} */ (reader.readString());
        msg.setYtdLongTermGain(value);
        break;
      case 32:
        var value = /** @type {string} */ (reader.readString());
        msg.setYtdLongTermLoss(value);
        break;
      case 33:
        var value = /** @type {string} */ (reader.readString());
        msg.setYtdLongTermNet(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ProfitAndLoss.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ProfitAndLoss.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ProfitAndLoss} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ProfitAndLoss.serializeBinaryToWriter = function(
  message,
  writer
) {
  var f = undefined;
  f = message.getProcessDate();
  if (f != null) {
    writer.writeMessage(1, f, google_type_date_pb.Date.serializeBinaryToWriter);
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(2, f);
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getOriginalCusip();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getAssetType();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
  f = message.getSymbolDescription();
  if (f.length > 0) {
    writer.writeString(11, f);
  }
  f = message.getRealized();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getMarketValue();
  if (f.length > 0) {
    writer.writeString(13, f);
  }
  f = message.getPlType();
  if (f.length > 0) {
    writer.writeString(16, f);
  }
  f = message.getYtdRealized();
  if (f.length > 0) {
    writer.writeString(17, f);
  }
  f = message.getSystemDate();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getSubAccountNo();
  if (f.length > 0) {
    writer.writeString(21, f);
  }
  f = message.getShortTermGain();
  if (f.length > 0) {
    writer.writeString(22, f);
  }
  f = message.getShortTermLoss();
  if (f.length > 0) {
    writer.writeString(23, f);
  }
  f = message.getShortTermNet();
  if (f.length > 0) {
    writer.writeString(24, f);
  }
  f = message.getLongTermGain();
  if (f.length > 0) {
    writer.writeString(25, f);
  }
  f = message.getLongTermLoss();
  if (f.length > 0) {
    writer.writeString(26, f);
  }
  f = message.getLongTermNet();
  if (f.length > 0) {
    writer.writeString(27, f);
  }
  f = message.getYtdShortTermGain();
  if (f.length > 0) {
    writer.writeString(28, f);
  }
  f = message.getYtdShortTermLoss();
  if (f.length > 0) {
    writer.writeString(29, f);
  }
  f = message.getYtdShortTermNet();
  if (f.length > 0) {
    writer.writeString(30, f);
  }
  f = message.getYtdLongTermGain();
  if (f.length > 0) {
    writer.writeString(31, f);
  }
  f = message.getYtdLongTermLoss();
  if (f.length > 0) {
    writer.writeString(32, f);
  }
  f = message.getYtdLongTermNet();
  if (f.length > 0) {
    writer.writeString(33, f);
  }
};

/**
 * optional google.type.Date process_date = 1;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ProfitAndLoss.prototype.getProcessDate = function() {
  return /** @type{?proto.google.type.Date} */ (jspb.Message.getWrapperField(
    this,
    google_type_date_pb.Date,
    1
  ));
};

/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setProcessDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.clearProcessDate = function() {
  return this.setProcessDate(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ProfitAndLoss.prototype.hasProcessDate = function() {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional uint32 account_id = 2;
 * @return {number}
 */
proto.reportpb.ProfitAndLoss.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/**
 * @param {number} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional string correspondent = 3;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string branch = 4;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string account_no = 5;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string master_account_no = 6;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string rep = 7;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getRep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setRep = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string original_cusip = 8;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getOriginalCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setOriginalCusip = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string asset_type = 9;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getAssetType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setAssetType = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional string symbol = 10;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * optional string symbol_description = 11;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getSymbolDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setSymbolDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};

/**
 * optional string realized = 12;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getRealized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setRealized = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * optional string market_value = 13;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};

/**
 * optional string pl_type = 16;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getPlType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setPlType = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};

/**
 * optional string ytd_realized = 17;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getYtdRealized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setYtdRealized = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};

/**
 * optional google.type.Date system_date = 18;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ProfitAndLoss.prototype.getSystemDate = function() {
  return /** @type{?proto.google.type.Date} */ (jspb.Message.getWrapperField(
    this,
    google_type_date_pb.Date,
    18
  ));
};

/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setSystemDate = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.clearSystemDate = function() {
  return this.setSystemDate(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ProfitAndLoss.prototype.hasSystemDate = function() {
  return jspb.Message.getField(this, 18) != null;
};

/**
 * optional string sub_account_no = 21;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getSubAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setSubAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};

/**
 * optional string short_term_gain = 22;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getShortTermGain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setShortTermGain = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};

/**
 * optional string short_term_loss = 23;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getShortTermLoss = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setShortTermLoss = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};

/**
 * optional string short_term_net = 24;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getShortTermNet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setShortTermNet = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};

/**
 * optional string long_term_gain = 25;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getLongTermGain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setLongTermGain = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};

/**
 * optional string long_term_loss = 26;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getLongTermLoss = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setLongTermLoss = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};

/**
 * optional string long_term_net = 27;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getLongTermNet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setLongTermNet = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};

/**
 * optional string ytd_short_term_gain = 28;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getYtdShortTermGain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setYtdShortTermGain = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};

/**
 * optional string ytd_short_term_loss = 29;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getYtdShortTermLoss = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setYtdShortTermLoss = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};

/**
 * optional string ytd_short_term_net = 30;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getYtdShortTermNet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setYtdShortTermNet = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};

/**
 * optional string ytd_long_term_gain = 31;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getYtdLongTermGain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setYtdLongTermGain = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};

/**
 * optional string ytd_long_term_loss = 32;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getYtdLongTermLoss = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setYtdLongTermLoss = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};

/**
 * optional string ytd_long_term_net = 33;
 * @return {string}
 */
proto.reportpb.ProfitAndLoss.prototype.getYtdLongTermNet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLoss} returns this
 */
proto.reportpb.ProfitAndLoss.prototype.setYtdLongTermNet = function(value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.reportpb.ProfitAndLossDetails.prototype.toObject = function(
    opt_includeInstance
  ) {
    return proto.reportpb.ProfitAndLossDetails.toObject(
      opt_includeInstance,
      this
    );
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.reportpb.ProfitAndLossDetails} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.reportpb.ProfitAndLossDetails.toObject = function(
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        processDate:
          (f = msg.getProcessDate()) &&
          google_type_date_pb.Date.toObject(includeInstance, f),
        buyDate:
          (f = msg.getBuyDate()) &&
          google_type_date_pb.Date.toObject(includeInstance, f),
        sellDate:
          (f = msg.getSellDate()) &&
          google_type_date_pb.Date.toObject(includeInstance, f),
        buyTrnsId: jspb.Message.getFieldWithDefault(msg, 4, 0),
        sellTrnsId: jspb.Message.getFieldWithDefault(msg, 5, 0),
        correspondent: jspb.Message.getFieldWithDefault(msg, 6, ''),
        branch: jspb.Message.getFieldWithDefault(msg, 7, ''),
        accountNo: jspb.Message.getFieldWithDefault(msg, 8, ''),
        masterAccountNo: jspb.Message.getFieldWithDefault(msg, 9, ''),
        rep: jspb.Message.getFieldWithDefault(msg, 10, ''),
        originalCusip: jspb.Message.getFieldWithDefault(msg, 11, ''),
        assetType: jspb.Message.getFieldWithDefault(msg, 12, ''),
        symbol: jspb.Message.getFieldWithDefault(msg, 13, ''),
        symbolDescription: jspb.Message.getFieldWithDefault(msg, 14, ''),
        plType: jspb.Message.getFieldWithDefault(msg, 15, ''),
        entryType: jspb.Message.getFieldWithDefault(msg, 16, ''),
        closedQty: jspb.Message.getFieldWithDefault(msg, 17, ''),
        buyPrice: jspb.Message.getFieldWithDefault(msg, 18, ''),
        sellPrice: jspb.Message.getFieldWithDefault(msg, 19, ''),
        buyNetAmt: jspb.Message.getFieldWithDefault(msg, 20, ''),
        sellNetAmt: jspb.Message.getFieldWithDefault(msg, 21, ''),
        realized: jspb.Message.getFieldWithDefault(msg, 22, ''),
        closingPrice: jspb.Message.getFieldWithDefault(msg, 26, ''),
        marketValue: jspb.Message.getFieldWithDefault(msg, 27, ''),
        accountId: jspb.Message.getFieldWithDefault(msg, 29, 0),
        ytdRealized: jspb.Message.getFieldWithDefault(msg, 30, ''),
        subAccountNo: jspb.Message.getFieldWithDefault(msg, 31, ''),
        shortTermGain: jspb.Message.getFieldWithDefault(msg, 32, ''),
        shortTermLoss: jspb.Message.getFieldWithDefault(msg, 33, ''),
        shortTermNet: jspb.Message.getFieldWithDefault(msg, 34, ''),
        longTermGain: jspb.Message.getFieldWithDefault(msg, 35, ''),
        longTermLoss: jspb.Message.getFieldWithDefault(msg, 36, ''),
        longTermNet: jspb.Message.getFieldWithDefault(msg, 37, ''),
        ytdShortTermGain: jspb.Message.getFieldWithDefault(msg, 38, ''),
        ytdShortTermLoss: jspb.Message.getFieldWithDefault(msg, 39, ''),
        ytdShortTermNet: jspb.Message.getFieldWithDefault(msg, 40, ''),
        ytdLongTermGain: jspb.Message.getFieldWithDefault(msg, 41, ''),
        ytdLongTermLoss: jspb.Message.getFieldWithDefault(msg, 42, ''),
        ytdLongTermNet: jspb.Message.getFieldWithDefault(msg, 43, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ProfitAndLossDetails}
 */
proto.reportpb.ProfitAndLossDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ProfitAndLossDetails();
  return proto.reportpb.ProfitAndLossDetails.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ProfitAndLossDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ProfitAndLossDetails}
 */
proto.reportpb.ProfitAndLossDetails.deserializeBinaryFromReader = function(
  msg,
  reader
) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new google_type_date_pb.Date();
        reader.readMessage(
          value,
          google_type_date_pb.Date.deserializeBinaryFromReader
        );
        msg.setProcessDate(value);
        break;
      case 2:
        var value = new google_type_date_pb.Date();
        reader.readMessage(
          value,
          google_type_date_pb.Date.deserializeBinaryFromReader
        );
        msg.setBuyDate(value);
        break;
      case 3:
        var value = new google_type_date_pb.Date();
        reader.readMessage(
          value,
          google_type_date_pb.Date.deserializeBinaryFromReader
        );
        msg.setSellDate(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setBuyTrnsId(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setSellTrnsId(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setCorrespondent(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setBranch(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setAccountNo(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setMasterAccountNo(value);
        break;
      case 10:
        var value = /** @type {string} */ (reader.readString());
        msg.setRep(value);
        break;
      case 11:
        var value = /** @type {string} */ (reader.readString());
        msg.setOriginalCusip(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setAssetType(value);
        break;
      case 13:
        var value = /** @type {string} */ (reader.readString());
        msg.setSymbol(value);
        break;
      case 14:
        var value = /** @type {string} */ (reader.readString());
        msg.setSymbolDescription(value);
        break;
      case 15:
        var value = /** @type {string} */ (reader.readString());
        msg.setPlType(value);
        break;
      case 16:
        var value = /** @type {string} */ (reader.readString());
        msg.setEntryType(value);
        break;
      case 17:
        var value = /** @type {string} */ (reader.readString());
        msg.setClosedQty(value);
        break;
      case 18:
        var value = /** @type {string} */ (reader.readString());
        msg.setBuyPrice(value);
        break;
      case 19:
        var value = /** @type {string} */ (reader.readString());
        msg.setSellPrice(value);
        break;
      case 20:
        var value = /** @type {string} */ (reader.readString());
        msg.setBuyNetAmt(value);
        break;
      case 21:
        var value = /** @type {string} */ (reader.readString());
        msg.setSellNetAmt(value);
        break;
      case 22:
        var value = /** @type {string} */ (reader.readString());
        msg.setRealized(value);
        break;
      case 26:
        var value = /** @type {string} */ (reader.readString());
        msg.setClosingPrice(value);
        break;
      case 27:
        var value = /** @type {string} */ (reader.readString());
        msg.setMarketValue(value);
        break;
      case 29:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setAccountId(value);
        break;
      case 30:
        var value = /** @type {string} */ (reader.readString());
        msg.setYtdRealized(value);
        break;
      case 31:
        var value = /** @type {string} */ (reader.readString());
        msg.setSubAccountNo(value);
        break;
      case 32:
        var value = /** @type {string} */ (reader.readString());
        msg.setShortTermGain(value);
        break;
      case 33:
        var value = /** @type {string} */ (reader.readString());
        msg.setShortTermLoss(value);
        break;
      case 34:
        var value = /** @type {string} */ (reader.readString());
        msg.setShortTermNet(value);
        break;
      case 35:
        var value = /** @type {string} */ (reader.readString());
        msg.setLongTermGain(value);
        break;
      case 36:
        var value = /** @type {string} */ (reader.readString());
        msg.setLongTermLoss(value);
        break;
      case 37:
        var value = /** @type {string} */ (reader.readString());
        msg.setLongTermNet(value);
        break;
      case 38:
        var value = /** @type {string} */ (reader.readString());
        msg.setYtdShortTermGain(value);
        break;
      case 39:
        var value = /** @type {string} */ (reader.readString());
        msg.setYtdShortTermLoss(value);
        break;
      case 40:
        var value = /** @type {string} */ (reader.readString());
        msg.setYtdShortTermNet(value);
        break;
      case 41:
        var value = /** @type {string} */ (reader.readString());
        msg.setYtdLongTermGain(value);
        break;
      case 42:
        var value = /** @type {string} */ (reader.readString());
        msg.setYtdLongTermLoss(value);
        break;
      case 43:
        var value = /** @type {string} */ (reader.readString());
        msg.setYtdLongTermNet(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ProfitAndLossDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ProfitAndLossDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ProfitAndLossDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ProfitAndLossDetails.serializeBinaryToWriter = function(
  message,
  writer
) {
  var f = undefined;
  f = message.getProcessDate();
  if (f != null) {
    writer.writeMessage(1, f, google_type_date_pb.Date.serializeBinaryToWriter);
  }
  f = message.getBuyDate();
  if (f != null) {
    writer.writeMessage(2, f, google_type_date_pb.Date.serializeBinaryToWriter);
  }
  f = message.getSellDate();
  if (f != null) {
    writer.writeMessage(3, f, google_type_date_pb.Date.serializeBinaryToWriter);
  }
  f = message.getBuyTrnsId();
  if (f !== 0) {
    writer.writeUint32(4, f);
  }
  f = message.getSellTrnsId();
  if (f !== 0) {
    writer.writeUint32(5, f);
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
  f = message.getOriginalCusip();
  if (f.length > 0) {
    writer.writeString(11, f);
  }
  f = message.getAssetType();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(13, f);
  }
  f = message.getSymbolDescription();
  if (f.length > 0) {
    writer.writeString(14, f);
  }
  f = message.getPlType();
  if (f.length > 0) {
    writer.writeString(15, f);
  }
  f = message.getEntryType();
  if (f.length > 0) {
    writer.writeString(16, f);
  }
  f = message.getClosedQty();
  if (f.length > 0) {
    writer.writeString(17, f);
  }
  f = message.getBuyPrice();
  if (f.length > 0) {
    writer.writeString(18, f);
  }
  f = message.getSellPrice();
  if (f.length > 0) {
    writer.writeString(19, f);
  }
  f = message.getBuyNetAmt();
  if (f.length > 0) {
    writer.writeString(20, f);
  }
  f = message.getSellNetAmt();
  if (f.length > 0) {
    writer.writeString(21, f);
  }
  f = message.getRealized();
  if (f.length > 0) {
    writer.writeString(22, f);
  }
  f = message.getClosingPrice();
  if (f.length > 0) {
    writer.writeString(26, f);
  }
  f = message.getMarketValue();
  if (f.length > 0) {
    writer.writeString(27, f);
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(29, f);
  }
  f = message.getYtdRealized();
  if (f.length > 0) {
    writer.writeString(30, f);
  }
  f = message.getSubAccountNo();
  if (f.length > 0) {
    writer.writeString(31, f);
  }
  f = message.getShortTermGain();
  if (f.length > 0) {
    writer.writeString(32, f);
  }
  f = message.getShortTermLoss();
  if (f.length > 0) {
    writer.writeString(33, f);
  }
  f = message.getShortTermNet();
  if (f.length > 0) {
    writer.writeString(34, f);
  }
  f = message.getLongTermGain();
  if (f.length > 0) {
    writer.writeString(35, f);
  }
  f = message.getLongTermLoss();
  if (f.length > 0) {
    writer.writeString(36, f);
  }
  f = message.getLongTermNet();
  if (f.length > 0) {
    writer.writeString(37, f);
  }
  f = message.getYtdShortTermGain();
  if (f.length > 0) {
    writer.writeString(38, f);
  }
  f = message.getYtdShortTermLoss();
  if (f.length > 0) {
    writer.writeString(39, f);
  }
  f = message.getYtdShortTermNet();
  if (f.length > 0) {
    writer.writeString(40, f);
  }
  f = message.getYtdLongTermGain();
  if (f.length > 0) {
    writer.writeString(41, f);
  }
  f = message.getYtdLongTermLoss();
  if (f.length > 0) {
    writer.writeString(42, f);
  }
  f = message.getYtdLongTermNet();
  if (f.length > 0) {
    writer.writeString(43, f);
  }
};

/**
 * optional google.type.Date process_date = 1;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getProcessDate = function() {
  return /** @type{?proto.google.type.Date} */ (jspb.Message.getWrapperField(
    this,
    google_type_date_pb.Date,
    1
  ));
};

/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setProcessDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.clearProcessDate = function() {
  return this.setProcessDate(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ProfitAndLossDetails.prototype.hasProcessDate = function() {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional google.type.Date buy_date = 2;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getBuyDate = function() {
  return /** @type{?proto.google.type.Date} */ (jspb.Message.getWrapperField(
    this,
    google_type_date_pb.Date,
    2
  ));
};

/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setBuyDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.clearBuyDate = function() {
  return this.setBuyDate(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ProfitAndLossDetails.prototype.hasBuyDate = function() {
  return jspb.Message.getField(this, 2) != null;
};

/**
 * optional google.type.Date sell_date = 3;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getSellDate = function() {
  return /** @type{?proto.google.type.Date} */ (jspb.Message.getWrapperField(
    this,
    google_type_date_pb.Date,
    3
  ));
};

/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setSellDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.clearSellDate = function() {
  return this.setSellDate(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ProfitAndLossDetails.prototype.hasSellDate = function() {
  return jspb.Message.getField(this, 3) != null;
};

/**
 * optional uint32 buy_trns_id = 4;
 * @return {number}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getBuyTrnsId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};

/**
 * @param {number} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setBuyTrnsId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};

/**
 * optional uint32 sell_trns_id = 5;
 * @return {number}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getSellTrnsId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};

/**
 * @param {number} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setSellTrnsId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};

/**
 * optional string correspondent = 6;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setCorrespondent = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string branch = 7;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string account_no = 8;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string master_account_no = 9;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setMasterAccountNo = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional string rep = 10;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getRep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setRep = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * optional string original_cusip = 11;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getOriginalCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setOriginalCusip = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 11, value);
};

/**
 * optional string asset_type = 12;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getAssetType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setAssetType = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * optional string symbol = 13;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};

/**
 * optional string symbol_description = 14;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getSymbolDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setSymbolDescription = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 14, value);
};

/**
 * optional string pl_type = 15;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getPlType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setPlType = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};

/**
 * optional string entry_type = 16;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getEntryType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setEntryType = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};

/**
 * optional string closed_qty = 17;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getClosedQty = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setClosedQty = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};

/**
 * optional string buy_price = 18;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getBuyPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setBuyPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};

/**
 * optional string sell_price = 19;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getSellPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setSellPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};

/**
 * optional string buy_net_amt = 20;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getBuyNetAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setBuyNetAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};

/**
 * optional string sell_net_amt = 21;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getSellNetAmt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setSellNetAmt = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};

/**
 * optional string realized = 22;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getRealized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setRealized = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};

/**
 * optional string closing_price = 26;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getClosingPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setClosingPrice = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 26, value);
};

/**
 * optional string market_value = 27;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};

/**
 * optional uint32 account_id = 29;
 * @return {number}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};

/**
 * @param {number} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 29, value);
};

/**
 * optional string ytd_realized = 30;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getYtdRealized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setYtdRealized = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};

/**
 * optional string sub_account_no = 31;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getSubAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setSubAccountNo = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 31, value);
};

/**
 * optional string short_term_gain = 32;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getShortTermGain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setShortTermGain = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 32, value);
};

/**
 * optional string short_term_loss = 33;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getShortTermLoss = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setShortTermLoss = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 33, value);
};

/**
 * optional string short_term_net = 34;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getShortTermNet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setShortTermNet = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 34, value);
};

/**
 * optional string long_term_gain = 35;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getLongTermGain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setLongTermGain = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 35, value);
};

/**
 * optional string long_term_loss = 36;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getLongTermLoss = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setLongTermLoss = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 36, value);
};

/**
 * optional string long_term_net = 37;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getLongTermNet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setLongTermNet = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};

/**
 * optional string ytd_short_term_gain = 38;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getYtdShortTermGain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setYtdShortTermGain = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 38, value);
};

/**
 * optional string ytd_short_term_loss = 39;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getYtdShortTermLoss = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setYtdShortTermLoss = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 39, value);
};

/**
 * optional string ytd_short_term_net = 40;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getYtdShortTermNet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setYtdShortTermNet = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 40, value);
};

/**
 * optional string ytd_long_term_gain = 41;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getYtdLongTermGain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 41, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setYtdLongTermGain = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 41, value);
};

/**
 * optional string ytd_long_term_loss = 42;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getYtdLongTermLoss = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 42, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setYtdLongTermLoss = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 42, value);
};

/**
 * optional string ytd_long_term_net = 43;
 * @return {string}
 */
proto.reportpb.ProfitAndLossDetails.prototype.getYtdLongTermNet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 43, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ProfitAndLossDetails} returns this
 */
proto.reportpb.ProfitAndLossDetails.prototype.setYtdLongTermNet = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 43, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.reportpb.ListProfitAndLossRequest.prototype.toObject = function(
    opt_includeInstance
  ) {
    return proto.reportpb.ListProfitAndLossRequest.toObject(
      opt_includeInstance,
      this
    );
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.reportpb.ListProfitAndLossRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.reportpb.ListProfitAndLossRequest.toObject = function(
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        fromDate:
          (f = msg.getFromDate()) &&
          google_type_date_pb.Date.toObject(includeInstance, f),
        toDate:
          (f = msg.getToDate()) &&
          google_type_date_pb.Date.toObject(includeInstance, f),
        correspondent: jspb.Message.getFieldWithDefault(msg, 3, ''),
        branch: jspb.Message.getFieldWithDefault(msg, 4, ''),
        accountNo: jspb.Message.getFieldWithDefault(msg, 5, ''),
        masterAccountNo: jspb.Message.getFieldWithDefault(msg, 6, ''),
        rep: jspb.Message.getFieldWithDefault(msg, 7, ''),
        assetType: jspb.Message.getFieldWithDefault(msg, 8, ''),
        symbol: jspb.Message.getFieldWithDefault(msg, 9, ''),
        plType: jspb.Message.getFieldWithDefault(msg, 10, ''),
        pagination:
          (f = msg.getPagination()) &&
          proto_utilspb_pagination_pb.Pagination.toObject(includeInstance, f),
        originalCusip: jspb.Message.getFieldWithDefault(msg, 12, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListProfitAndLossRequest}
 */
proto.reportpb.ListProfitAndLossRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListProfitAndLossRequest();
  return proto.reportpb.ListProfitAndLossRequest.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListProfitAndLossRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListProfitAndLossRequest}
 */
proto.reportpb.ListProfitAndLossRequest.deserializeBinaryFromReader = function(
  msg,
  reader
) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new google_type_date_pb.Date();
        reader.readMessage(
          value,
          google_type_date_pb.Date.deserializeBinaryFromReader
        );
        msg.setFromDate(value);
        break;
      case 2:
        var value = new google_type_date_pb.Date();
        reader.readMessage(
          value,
          google_type_date_pb.Date.deserializeBinaryFromReader
        );
        msg.setToDate(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setCorrespondent(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setBranch(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setAccountNo(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setMasterAccountNo(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setRep(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setAssetType(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setSymbol(value);
        break;
      case 10:
        var value = /** @type {string} */ (reader.readString());
        msg.setPlType(value);
        break;
      case 11:
        var value = new proto_utilspb_pagination_pb.Pagination();
        reader.readMessage(
          value,
          proto_utilspb_pagination_pb.Pagination.deserializeBinaryFromReader
        );
        msg.setPagination(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setOriginalCusip(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListProfitAndLossRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListProfitAndLossRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListProfitAndLossRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListProfitAndLossRequest.serializeBinaryToWriter = function(
  message,
  writer
) {
  var f = undefined;
  f = message.getFromDate();
  if (f != null) {
    writer.writeMessage(1, f, google_type_date_pb.Date.serializeBinaryToWriter);
  }
  f = message.getToDate();
  if (f != null) {
    writer.writeMessage(2, f, google_type_date_pb.Date.serializeBinaryToWriter);
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getAssetType();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getPlType();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto_utilspb_pagination_pb.Pagination.serializeBinaryToWriter
    );
  }
  f = message.getOriginalCusip();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
};

/**
 * optional google.type.Date from_date = 1;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ListProfitAndLossRequest.prototype.getFromDate = function() {
  return /** @type{?proto.google.type.Date} */ (jspb.Message.getWrapperField(
    this,
    google_type_date_pb.Date,
    1
  ));
};

/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ListProfitAndLossRequest} returns this
 */
proto.reportpb.ListProfitAndLossRequest.prototype.setFromDate = function(
  value
) {
  return jspb.Message.setWrapperField(this, 1, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListProfitAndLossRequest} returns this
 */
proto.reportpb.ListProfitAndLossRequest.prototype.clearFromDate = function() {
  return this.setFromDate(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListProfitAndLossRequest.prototype.hasFromDate = function() {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional google.type.Date to_date = 2;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ListProfitAndLossRequest.prototype.getToDate = function() {
  return /** @type{?proto.google.type.Date} */ (jspb.Message.getWrapperField(
    this,
    google_type_date_pb.Date,
    2
  ));
};

/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ListProfitAndLossRequest} returns this
 */
proto.reportpb.ListProfitAndLossRequest.prototype.setToDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListProfitAndLossRequest} returns this
 */
proto.reportpb.ListProfitAndLossRequest.prototype.clearToDate = function() {
  return this.setToDate(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListProfitAndLossRequest.prototype.hasToDate = function() {
  return jspb.Message.getField(this, 2) != null;
};

/**
 * optional string correspondent = 3;
 * @return {string}
 */
proto.reportpb.ListProfitAndLossRequest.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListProfitAndLossRequest} returns this
 */
proto.reportpb.ListProfitAndLossRequest.prototype.setCorrespondent = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string branch = 4;
 * @return {string}
 */
proto.reportpb.ListProfitAndLossRequest.prototype.getBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListProfitAndLossRequest} returns this
 */
proto.reportpb.ListProfitAndLossRequest.prototype.setBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string account_no = 5;
 * @return {string}
 */
proto.reportpb.ListProfitAndLossRequest.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListProfitAndLossRequest} returns this
 */
proto.reportpb.ListProfitAndLossRequest.prototype.setAccountNo = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string master_account_no = 6;
 * @return {string}
 */
proto.reportpb.ListProfitAndLossRequest.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListProfitAndLossRequest} returns this
 */
proto.reportpb.ListProfitAndLossRequest.prototype.setMasterAccountNo = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string rep = 7;
 * @return {string}
 */
proto.reportpb.ListProfitAndLossRequest.prototype.getRep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListProfitAndLossRequest} returns this
 */
proto.reportpb.ListProfitAndLossRequest.prototype.setRep = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string asset_type = 8;
 * @return {string}
 */
proto.reportpb.ListProfitAndLossRequest.prototype.getAssetType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListProfitAndLossRequest} returns this
 */
proto.reportpb.ListProfitAndLossRequest.prototype.setAssetType = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string symbol = 9;
 * @return {string}
 */
proto.reportpb.ListProfitAndLossRequest.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListProfitAndLossRequest} returns this
 */
proto.reportpb.ListProfitAndLossRequest.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional string pl_type = 10;
 * @return {string}
 */
proto.reportpb.ListProfitAndLossRequest.prototype.getPlType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListProfitAndLossRequest} returns this
 */
proto.reportpb.ListProfitAndLossRequest.prototype.setPlType = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * optional utilspb.Pagination pagination = 11;
 * @return {?proto.utilspb.Pagination}
 */
proto.reportpb.ListProfitAndLossRequest.prototype.getPagination = function() {
  return /** @type{?proto.utilspb.Pagination} */ (jspb.Message.getWrapperField(
    this,
    proto_utilspb_pagination_pb.Pagination,
    11
  ));
};

/**
 * @param {?proto.utilspb.Pagination|undefined} value
 * @return {!proto.reportpb.ListProfitAndLossRequest} returns this
 */
proto.reportpb.ListProfitAndLossRequest.prototype.setPagination = function(
  value
) {
  return jspb.Message.setWrapperField(this, 11, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListProfitAndLossRequest} returns this
 */
proto.reportpb.ListProfitAndLossRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListProfitAndLossRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 11) != null;
};

/**
 * optional string original_cusip = 12;
 * @return {string}
 */
proto.reportpb.ListProfitAndLossRequest.prototype.getOriginalCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListProfitAndLossRequest} returns this
 */
proto.reportpb.ListProfitAndLossRequest.prototype.setOriginalCusip = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reportpb.ListProfitAndLossResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.reportpb.ListProfitAndLossResponse.prototype.toObject = function(
    opt_includeInstance
  ) {
    return proto.reportpb.ListProfitAndLossResponse.toObject(
      opt_includeInstance,
      this
    );
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.reportpb.ListProfitAndLossResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.reportpb.ListProfitAndLossResponse.toObject = function(
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        profitandlossList: jspb.Message.toObjectList(
          msg.getProfitandlossList(),
          proto.reportpb.ProfitAndLoss.toObject,
          includeInstance
        ),
        summary:
          (f = msg.getSummary()) &&
          proto.reportpb.ListProfitAndLossSummary.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListProfitAndLossResponse}
 */
proto.reportpb.ListProfitAndLossResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListProfitAndLossResponse();
  return proto.reportpb.ListProfitAndLossResponse.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListProfitAndLossResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListProfitAndLossResponse}
 */
proto.reportpb.ListProfitAndLossResponse.deserializeBinaryFromReader = function(
  msg,
  reader
) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.reportpb.ProfitAndLoss();
        reader.readMessage(
          value,
          proto.reportpb.ProfitAndLoss.deserializeBinaryFromReader
        );
        msg.addProfitandloss(value);
        break;
      case 2:
        var value = new proto.reportpb.ListProfitAndLossSummary();
        reader.readMessage(
          value,
          proto.reportpb.ListProfitAndLossSummary.deserializeBinaryFromReader
        );
        msg.setSummary(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListProfitAndLossResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListProfitAndLossResponse.serializeBinaryToWriter(
    this,
    writer
  );
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListProfitAndLossResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListProfitAndLossResponse.serializeBinaryToWriter = function(
  message,
  writer
) {
  var f = undefined;
  f = message.getProfitandlossList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.reportpb.ProfitAndLoss.serializeBinaryToWriter
    );
  }
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.reportpb.ListProfitAndLossSummary.serializeBinaryToWriter
    );
  }
};

/**
 * repeated ProfitAndLoss ProfitAndLoss = 1;
 * @return {!Array<!proto.reportpb.ProfitAndLoss>}
 */
proto.reportpb.ListProfitAndLossResponse.prototype.getProfitandlossList = function() {
  return /** @type{!Array<!proto.reportpb.ProfitAndLoss>} */ (jspb.Message.getRepeatedWrapperField(
    this,
    proto.reportpb.ProfitAndLoss,
    1
  ));
};

/**
 * @param {!Array<!proto.reportpb.ProfitAndLoss>} value
 * @return {!proto.reportpb.ListProfitAndLossResponse} returns this
 */
proto.reportpb.ListProfitAndLossResponse.prototype.setProfitandlossList = function(
  value
) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};

/**
 * @param {!proto.reportpb.ProfitAndLoss=} opt_value
 * @param {number=} opt_index
 * @return {!proto.reportpb.ProfitAndLoss}
 */
proto.reportpb.ListProfitAndLossResponse.prototype.addProfitandloss = function(
  opt_value,
  opt_index
) {
  return jspb.Message.addToRepeatedWrapperField(
    this,
    1,
    opt_value,
    proto.reportpb.ProfitAndLoss,
    opt_index
  );
};

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ListProfitAndLossResponse} returns this
 */
proto.reportpb.ListProfitAndLossResponse.prototype.clearProfitandlossList = function() {
  return this.setProfitandlossList([]);
};

/**
 * optional ListProfitAndLossSummary summary = 2;
 * @return {?proto.reportpb.ListProfitAndLossSummary}
 */
proto.reportpb.ListProfitAndLossResponse.prototype.getSummary = function() {
  return /** @type{?proto.reportpb.ListProfitAndLossSummary} */ (jspb.Message.getWrapperField(
    this,
    proto.reportpb.ListProfitAndLossSummary,
    2
  ));
};

/**
 * @param {?proto.reportpb.ListProfitAndLossSummary|undefined} value
 * @return {!proto.reportpb.ListProfitAndLossResponse} returns this
 */
proto.reportpb.ListProfitAndLossResponse.prototype.setSummary = function(
  value
) {
  return jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListProfitAndLossResponse} returns this
 */
proto.reportpb.ListProfitAndLossResponse.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListProfitAndLossResponse.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 2) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.reportpb.ListProfitAndLossSummary.prototype.toObject = function(
    opt_includeInstance
  ) {
    return proto.reportpb.ListProfitAndLossSummary.toObject(
      opt_includeInstance,
      this
    );
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.reportpb.ListProfitAndLossSummary} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.reportpb.ListProfitAndLossSummary.toObject = function(
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        totalRows: jspb.Message.getFieldWithDefault(msg, 1, 0),
        marketValue: jspb.Message.getFieldWithDefault(msg, 2, ''),
        realized: jspb.Message.getFieldWithDefault(msg, 3, ''),
        ytdRealized: jspb.Message.getFieldWithDefault(msg, 4, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListProfitAndLossSummary}
 */
proto.reportpb.ListProfitAndLossSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListProfitAndLossSummary();
  return proto.reportpb.ListProfitAndLossSummary.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListProfitAndLossSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListProfitAndLossSummary}
 */
proto.reportpb.ListProfitAndLossSummary.deserializeBinaryFromReader = function(
  msg,
  reader
) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setTotalRows(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setMarketValue(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setRealized(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setYtdRealized(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListProfitAndLossSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListProfitAndLossSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListProfitAndLossSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListProfitAndLossSummary.serializeBinaryToWriter = function(
  message,
  writer
) {
  var f = undefined;
  f = message.getTotalRows();
  if (f !== 0) {
    writer.writeUint32(1, f);
  }
  f = message.getMarketValue();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getRealized();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getYtdRealized();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
};

/**
 * optional uint32 total_rows = 1;
 * @return {number}
 */
proto.reportpb.ListProfitAndLossSummary.prototype.getTotalRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/**
 * @param {number} value
 * @return {!proto.reportpb.ListProfitAndLossSummary} returns this
 */
proto.reportpb.ListProfitAndLossSummary.prototype.setTotalRows = function(
  value
) {
  return jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string market_value = 2;
 * @return {string}
 */
proto.reportpb.ListProfitAndLossSummary.prototype.getMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListProfitAndLossSummary} returns this
 */
proto.reportpb.ListProfitAndLossSummary.prototype.setMarketValue = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string realized = 3;
 * @return {string}
 */
proto.reportpb.ListProfitAndLossSummary.prototype.getRealized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListProfitAndLossSummary} returns this
 */
proto.reportpb.ListProfitAndLossSummary.prototype.setRealized = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string ytd_realized = 4;
 * @return {string}
 */
proto.reportpb.ListProfitAndLossSummary.prototype.getYtdRealized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListProfitAndLossSummary} returns this
 */
proto.reportpb.ListProfitAndLossSummary.prototype.setYtdRealized = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 4, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.reportpb.ListDetailsProfitAndLossRequest.prototype.toObject = function(
    opt_includeInstance
  ) {
    return proto.reportpb.ListDetailsProfitAndLossRequest.toObject(
      opt_includeInstance,
      this
    );
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.reportpb.ListDetailsProfitAndLossRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.reportpb.ListDetailsProfitAndLossRequest.toObject = function(
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        processDate:
          (f = msg.getProcessDate()) &&
          google_type_date_pb.Date.toObject(includeInstance, f),
        accountId: jspb.Message.getFieldWithDefault(msg, 2, 0),
        originalCusip: jspb.Message.getFieldWithDefault(msg, 3, ''),
        pagination:
          (f = msg.getPagination()) &&
          proto_utilspb_pagination_pb.Pagination.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListDetailsProfitAndLossRequest}
 */
proto.reportpb.ListDetailsProfitAndLossRequest.deserializeBinary = function(
  bytes
) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListDetailsProfitAndLossRequest();
  return proto.reportpb.ListDetailsProfitAndLossRequest.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListDetailsProfitAndLossRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListDetailsProfitAndLossRequest}
 */
proto.reportpb.ListDetailsProfitAndLossRequest.deserializeBinaryFromReader = function(
  msg,
  reader
) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new google_type_date_pb.Date();
        reader.readMessage(
          value,
          google_type_date_pb.Date.deserializeBinaryFromReader
        );
        msg.setProcessDate(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setAccountId(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setOriginalCusip(value);
        break;
      case 4:
        var value = new proto_utilspb_pagination_pb.Pagination();
        reader.readMessage(
          value,
          proto_utilspb_pagination_pb.Pagination.deserializeBinaryFromReader
        );
        msg.setPagination(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListDetailsProfitAndLossRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListDetailsProfitAndLossRequest.serializeBinaryToWriter(
    this,
    writer
  );
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListDetailsProfitAndLossRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListDetailsProfitAndLossRequest.serializeBinaryToWriter = function(
  message,
  writer
) {
  var f = undefined;
  f = message.getProcessDate();
  if (f != null) {
    writer.writeMessage(1, f, google_type_date_pb.Date.serializeBinaryToWriter);
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(2, f);
  }
  f = message.getOriginalCusip();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto_utilspb_pagination_pb.Pagination.serializeBinaryToWriter
    );
  }
};

/**
 * optional google.type.Date process_date = 1;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ListDetailsProfitAndLossRequest.prototype.getProcessDate = function() {
  return /** @type{?proto.google.type.Date} */ (jspb.Message.getWrapperField(
    this,
    google_type_date_pb.Date,
    1
  ));
};

/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ListDetailsProfitAndLossRequest} returns this
 */
proto.reportpb.ListDetailsProfitAndLossRequest.prototype.setProcessDate = function(
  value
) {
  return jspb.Message.setWrapperField(this, 1, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListDetailsProfitAndLossRequest} returns this
 */
proto.reportpb.ListDetailsProfitAndLossRequest.prototype.clearProcessDate = function() {
  return this.setProcessDate(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListDetailsProfitAndLossRequest.prototype.hasProcessDate = function() {
  return jspb.Message.getField(this, 1) != null;
};

/**
 * optional uint32 account_id = 2;
 * @return {number}
 */
proto.reportpb.ListDetailsProfitAndLossRequest.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};

/**
 * @param {number} value
 * @return {!proto.reportpb.ListDetailsProfitAndLossRequest} returns this
 */
proto.reportpb.ListDetailsProfitAndLossRequest.prototype.setAccountId = function(
  value
) {
  return jspb.Message.setProto3IntField(this, 2, value);
};

/**
 * optional string original_cusip = 3;
 * @return {string}
 */
proto.reportpb.ListDetailsProfitAndLossRequest.prototype.getOriginalCusip = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListDetailsProfitAndLossRequest} returns this
 */
proto.reportpb.ListDetailsProfitAndLossRequest.prototype.setOriginalCusip = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional utilspb.Pagination pagination = 4;
 * @return {?proto.utilspb.Pagination}
 */
proto.reportpb.ListDetailsProfitAndLossRequest.prototype.getPagination = function() {
  return /** @type{?proto.utilspb.Pagination} */ (jspb.Message.getWrapperField(
    this,
    proto_utilspb_pagination_pb.Pagination,
    4
  ));
};

/**
 * @param {?proto.utilspb.Pagination|undefined} value
 * @return {!proto.reportpb.ListDetailsProfitAndLossRequest} returns this
 */
proto.reportpb.ListDetailsProfitAndLossRequest.prototype.setPagination = function(
  value
) {
  return jspb.Message.setWrapperField(this, 4, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListDetailsProfitAndLossRequest} returns this
 */
proto.reportpb.ListDetailsProfitAndLossRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListDetailsProfitAndLossRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 4) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.reportpb.ListDetailsProfitAndLossSummary.prototype.toObject = function(
    opt_includeInstance
  ) {
    return proto.reportpb.ListDetailsProfitAndLossSummary.toObject(
      opt_includeInstance,
      this
    );
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.reportpb.ListDetailsProfitAndLossSummary} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.reportpb.ListDetailsProfitAndLossSummary.toObject = function(
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        totalRows: jspb.Message.getFieldWithDefault(msg, 1, 0),
        realized: jspb.Message.getFieldWithDefault(msg, 2, ''),
        marketValue: jspb.Message.getFieldWithDefault(msg, 3, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListDetailsProfitAndLossSummary}
 */
proto.reportpb.ListDetailsProfitAndLossSummary.deserializeBinary = function(
  bytes
) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListDetailsProfitAndLossSummary();
  return proto.reportpb.ListDetailsProfitAndLossSummary.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListDetailsProfitAndLossSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListDetailsProfitAndLossSummary}
 */
proto.reportpb.ListDetailsProfitAndLossSummary.deserializeBinaryFromReader = function(
  msg,
  reader
) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setTotalRows(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setRealized(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setMarketValue(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListDetailsProfitAndLossSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListDetailsProfitAndLossSummary.serializeBinaryToWriter(
    this,
    writer
  );
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListDetailsProfitAndLossSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListDetailsProfitAndLossSummary.serializeBinaryToWriter = function(
  message,
  writer
) {
  var f = undefined;
  f = message.getTotalRows();
  if (f !== 0) {
    writer.writeUint32(1, f);
  }
  f = message.getRealized();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getMarketValue();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
};

/**
 * optional uint32 total_rows = 1;
 * @return {number}
 */
proto.reportpb.ListDetailsProfitAndLossSummary.prototype.getTotalRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/**
 * @param {number} value
 * @return {!proto.reportpb.ListDetailsProfitAndLossSummary} returns this
 */
proto.reportpb.ListDetailsProfitAndLossSummary.prototype.setTotalRows = function(
  value
) {
  return jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string realized = 2;
 * @return {string}
 */
proto.reportpb.ListDetailsProfitAndLossSummary.prototype.getRealized = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListDetailsProfitAndLossSummary} returns this
 */
proto.reportpb.ListDetailsProfitAndLossSummary.prototype.setRealized = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string market_value = 3;
 * @return {string}
 */
proto.reportpb.ListDetailsProfitAndLossSummary.prototype.getMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListDetailsProfitAndLossSummary} returns this
 */
proto.reportpb.ListDetailsProfitAndLossSummary.prototype.setMarketValue = function(
  value
) {
  return jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reportpb.ListDetailsProfitAndLossResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.reportpb.ListDetailsProfitAndLossResponse.prototype.toObject = function(
    opt_includeInstance
  ) {
    return proto.reportpb.ListDetailsProfitAndLossResponse.toObject(
      opt_includeInstance,
      this
    );
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.reportpb.ListDetailsProfitAndLossResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.reportpb.ListDetailsProfitAndLossResponse.toObject = function(
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        profitandlossdetailsList: jspb.Message.toObjectList(
          msg.getProfitandlossdetailsList(),
          proto.reportpb.ProfitAndLossDetails.toObject,
          includeInstance
        ),
        summary:
          (f = msg.getSummary()) &&
          proto.reportpb.ListDetailsProfitAndLossSummary.toObject(
            includeInstance,
            f
          ),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListDetailsProfitAndLossResponse}
 */
proto.reportpb.ListDetailsProfitAndLossResponse.deserializeBinary = function(
  bytes
) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListDetailsProfitAndLossResponse();
  return proto.reportpb.ListDetailsProfitAndLossResponse.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListDetailsProfitAndLossResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListDetailsProfitAndLossResponse}
 */
proto.reportpb.ListDetailsProfitAndLossResponse.deserializeBinaryFromReader = function(
  msg,
  reader
) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.reportpb.ProfitAndLossDetails();
        reader.readMessage(
          value,
          proto.reportpb.ProfitAndLossDetails.deserializeBinaryFromReader
        );
        msg.addProfitandlossdetails(value);
        break;
      case 2:
        var value = new proto.reportpb.ListDetailsProfitAndLossSummary();
        reader.readMessage(
          value,
          proto.reportpb.ListDetailsProfitAndLossSummary
            .deserializeBinaryFromReader
        );
        msg.setSummary(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListDetailsProfitAndLossResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListDetailsProfitAndLossResponse.serializeBinaryToWriter(
    this,
    writer
  );
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListDetailsProfitAndLossResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListDetailsProfitAndLossResponse.serializeBinaryToWriter = function(
  message,
  writer
) {
  var f = undefined;
  f = message.getProfitandlossdetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.reportpb.ProfitAndLossDetails.serializeBinaryToWriter
    );
  }
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.reportpb.ListDetailsProfitAndLossSummary.serializeBinaryToWriter
    );
  }
};

/**
 * repeated ProfitAndLossDetails ProfitAndLossDetails = 1;
 * @return {!Array<!proto.reportpb.ProfitAndLossDetails>}
 */
proto.reportpb.ListDetailsProfitAndLossResponse.prototype.getProfitandlossdetailsList = function() {
  return /** @type{!Array<!proto.reportpb.ProfitAndLossDetails>} */ (jspb.Message.getRepeatedWrapperField(
    this,
    proto.reportpb.ProfitAndLossDetails,
    1
  ));
};

/**
 * @param {!Array<!proto.reportpb.ProfitAndLossDetails>} value
 * @return {!proto.reportpb.ListDetailsProfitAndLossResponse} returns this
 */
proto.reportpb.ListDetailsProfitAndLossResponse.prototype.setProfitandlossdetailsList = function(
  value
) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};

/**
 * @param {!proto.reportpb.ProfitAndLossDetails=} opt_value
 * @param {number=} opt_index
 * @return {!proto.reportpb.ProfitAndLossDetails}
 */
proto.reportpb.ListDetailsProfitAndLossResponse.prototype.addProfitandlossdetails = function(
  opt_value,
  opt_index
) {
  return jspb.Message.addToRepeatedWrapperField(
    this,
    1,
    opt_value,
    proto.reportpb.ProfitAndLossDetails,
    opt_index
  );
};

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ListDetailsProfitAndLossResponse} returns this
 */
proto.reportpb.ListDetailsProfitAndLossResponse.prototype.clearProfitandlossdetailsList = function() {
  return this.setProfitandlossdetailsList([]);
};

/**
 * optional ListDetailsProfitAndLossSummary summary = 2;
 * @return {?proto.reportpb.ListDetailsProfitAndLossSummary}
 */
proto.reportpb.ListDetailsProfitAndLossResponse.prototype.getSummary = function() {
  return /** @type{?proto.reportpb.ListDetailsProfitAndLossSummary} */ (jspb.Message.getWrapperField(
    this,
    proto.reportpb.ListDetailsProfitAndLossSummary,
    2
  ));
};

/**
 * @param {?proto.reportpb.ListDetailsProfitAndLossSummary|undefined} value
 * @return {!proto.reportpb.ListDetailsProfitAndLossResponse} returns this
 */
proto.reportpb.ListDetailsProfitAndLossResponse.prototype.setSummary = function(
  value
) {
  return jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListDetailsProfitAndLossResponse} returns this
 */
proto.reportpb.ListDetailsProfitAndLossResponse.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListDetailsProfitAndLossResponse.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 2) != null;
};

goog.object.extend(exports, proto.reportpb);
